export interface SaldosReportes {
    fecha: any;
    hora: any;
    numeroDeRegistros : number;
    saldoTotalDebito: number;
    saldoTotalCredito: number;
    balancesByType: [
        {
            tipoDeCuenta: string;
            totalCredito: number;
            totalDebito: number;
            balanceDetalle: [
                {
                    dpi: string;
                    nombre: string;
                    debito: number;
                    credito: number;
                    descripcion: string
                }
        ]
        }
    ]
}

export class SaldosReportes implements SaldosReportes {
    constructor(init: SaldosReportesFormValues) {
        Object.assign(this, init);
    }
}

export class SaldosReportesFormValues {
    fecha: string = "";
    hora: string = "";
    saldoTotalDebito: number = 0;
    numeroDeRegistros: number = 0;
    saldoTotalCredito: number = 0;
    dpi: string = "";
    nombre: string = "";
    descripcion: string = "";
    tipoDeCuenta: string = "";
    totalCredito: number = 0;
    totalDebito: number = 0;
    debito: number = 0;
    credito: number = 0;

    constructor(SaldosReportes?: SaldosReportesFormValues) {
        if(SaldosReportes){
            this.numeroDeRegistros = SaldosReportes.numeroDeRegistros;
            this.tipoDeCuenta = SaldosReportes.tipoDeCuenta;
            this.fecha = SaldosReportes.fecha;
            this.dpi = SaldosReportes.dpi;
            this.nombre = SaldosReportes.nombre;
            this.descripcion = SaldosReportes.descripcion;
            this.hora = SaldosReportes.hora;
            this.saldoTotalCredito = SaldosReportes.saldoTotalCredito;
            this.saldoTotalDebito = SaldosReportes.saldoTotalDebito;
            this.totalCredito = SaldosReportes.totalCredito;
            this.totalDebito = SaldosReportes.totalDebito;
            this.debito = SaldosReportes.debito;
            this.credito = SaldosReportes.credito
        }
    }
}
